// Saving an OA debrief from outside Interview Prep (Home's banner, a card's
// emails panel): the same doc Interview Prep reads (users/{uid}/prepEvents/{cardId}),
// so a debrief written in one place is done everywhere.

import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import type { ApiItem } from "./applicationCards";
import { shareDebrief } from "./companyDebriefs";
import { detectOaKind, type Debrief, type PrepEventDoc } from "./prepEvents";

export function saveDebrief(uid: string, card: ApiItem, answers: Debrief, saved?: PrepEventDoc): Promise<void> {
  const kind = saved?.kind ?? detectOaKind(card);
  shareDebrief(uid, card, answers, kind).catch((e) => console.warn("Could not share the debrief:", e));
  return setDoc(
    doc(db, "users", uid, "prepEvents", card.id),
    {
      debrief: { ...answers, ...(card.company ? { company: card.company } : {}), ...(card.role ? { role: card.role } : {}) },
      debriefed: true,
    },
    { merge: true }
  );
}

/** "Skip debrief": it stops asking, with nothing written */
export function skipDebrief(uid: string, cardId: string): Promise<void> {
  return setDoc(doc(db, "users", uid, "prepEvents", cardId), { debriefed: true }, { merge: true });
}
